<content-loading *ngIf="isLoading"></content-loading>
<form autocomplete="off" *ngIf="state.get('data').size" class="form mx-4">
  <property-photo-gallery
    *ngIf="imageBasePath"
    [images]="images"
    [imageTypes]="imageTypes"
    (upload)="upload($event)"
    (delete)="delete($event)"
    [shouldReload]="shouldReload"
    [imageBaseUrl]="imageBasePath"
    [editable]="propertyId"
    [isReadonly]="isReadonly"
  ></property-photo-gallery>
</form>
